"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const AccessibilityBar_1 = __importDefault(require("../../../consulta-acessibilidade/AccessibilityBar"));
const SuggestionsAndLinks_1 = __importDefault(require("../../components/mobile/SuggestionsAndLinks"));
const AppContextProvider_1 = require("../../../../shared/contexts/AppContextProvider");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const SearchBar_1 = __importDefault(require("../../components/SearchBar/SearchBar"));
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const Faqs_1 = __importDefault(require("../../components/mobile/Faqs"));
const MobileStyles_1 = require("../../components/mobile/styles/MobileStyles");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_i18next_1 = require("react-i18next");
const GuiasConteudoPersonalizado_1 = __importDefault(require("../../components/BaseTemplate/GuiasConteudoPersonalizado"));
const Secoes_1 = __importDefault(require("../../components/Home/Secoes"));
const helpers_1 = require("../../../../shared/helpers");
const components_1 = require("../../../../shared/components");
const AppMobileCommunicationContext_1 = require("../../../../shared/contexts/AppMobileCommunicationContext");
const MobileLayout = (props) => {
    const [isClassToggled, setIsClassToggled] = (0, react_1.useState)(false);
    // Função para alternar a classe
    const handleToggleClass = () => {
        setIsClassToggled(prevState => !prevState);
    };
    const { guiaSelecionada, opcoesConsultaRx, children, consultaRx, loadingRx } = props;
    const { setOnGoBackMobile, mobileView, setMobileView, faqsData, serviceData, sectionsData, changeHeaderTitle } = (0, AppContextProvider_1.useAppContext)();
    const history = (0, react_router_dom_1.useHistory)();
    const location = (0, react_router_dom_1.useLocation)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const { renderedByApp } = (0, AppMobileCommunicationContext_1.useAppMobileContext)();
    (0, react_1.useEffect)(() => {
        setOnGoBackMobile(() => {
            return () => {
                setMobileView(null);
            };
        });
        return () => {
            setOnGoBackMobile(null);
        };
    }, [setOnGoBackMobile]);
    const getPesquisa = () => {
        var _a;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(components_1.ModalConstructor, { open: loadingRx, size: "xs" },
                react_1.default.createElement("div", { className: "p-4 text-center" }, loadingRx && (react_1.default.createElement("div", null,
                    react_1.default.createElement(components_1.SpinnerConstructor, { visible: true, height: 60, width: 60, className: "apergamum" }),
                    react_1.default.createElement("div", { className: "mt-3" },
                        react_1.default.createElement("span", { className: "preto70 s17 f400" }, t('PesquisandoAguarde'))))))),
            ((_a = consultaRx === null || consultaRx === void 0 ? void 0 : consultaRx.data) === null || _a === void 0 ? void 0 : _a.length) > 0 ? (react_1.default.createElement("div", { className: 'fixoMobileBtn' },
                react_1.default.createElement(MobileStyles_1.MobileButton, { className: 'btn-generic--segundo ml-0 btn-responsivo', onClick: () => {
                        helpers_1.ConsultaHelper.limparConsulta();
                    } },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faSyncAlt, className: "icone-header mr-2" }),
                    t('MobileLayout.RefazerPesquisa')))) : (react_1.default.createElement(SearchBar_1.default, { opcoesConsulta: opcoesConsultaRx, guiaSelecionada: guiaSelecionada })),
            children,
            react_1.default.createElement(components_1.Footer, { showLinks: true })));
    };
    const getContent = () => {
        switch (mobileView) {
            case 'suggestions_and_links':
                return (react_1.default.createElement(SuggestionsAndLinks_1.default, null));
            case 'search':
                return getPesquisa();
            case 'faqs':
                return (react_1.default.createElement(Faqs_1.default, null));
            case 'services':
                return react_1.default.createElement(GuiasConteudoPersonalizado_1.default, null);
            case 'featured_and_news':
                return sectionsData && (sectionsData === null || sectionsData === void 0 ? void 0 : sectionsData.length) > 0 ? (react_1.default.createElement(Secoes_1.default, { secoes: sectionsData, guiaSelecionada: guiaSelecionada })) : '';
            default:
                null;
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", null,
            !renderedByApp ? (react_1.default.createElement(AccessibilityBar_1.default, null)) : '',
            [null, 'login'].includes(mobileView) ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: 'hmobile' }, getPesquisa()),
                react_1.default.createElement("div", { className: `secaoBtnMobileHome js-posicao1 ${isClassToggled ? 'js-posicao2' : ' '}` },
                    react_1.default.createElement("div", { className: 'px-2 py-3' },
                        react_1.default.createElement("button", { className: 'btn-mobile-footer--segundo ml-0 btn-responsivo', onClick: handleToggleClass },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { className: 's16 mr-1', icon: free_solid_svg_icons_1.faBars }),
                            "Ver mais"))),
                react_1.default.createElement("div", { className: `js-bgBlock  ${isClassToggled ? '' : 'd-none '}` }),
                react_1.default.createElement("div", { className: `secaoBtnMobileHome js-posicao2 ${isClassToggled ? 'js-posicao1' : ' '}` },
                    react_1.default.createElement(MobileStyles_1.MobileButtonOrganizer, { className: 'px-3 py-4' },
                        react_1.default.createElement("button", { className: 'btn-mobile-footer--segundo mb-4 ml-0', onClick: handleToggleClass },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { className: 's16 mr-1', icon: free_solid_svg_icons_1.faTimes }),
                            "Fechar"),
                        react_1.default.createElement(MobileStyles_1.MobileButton, { className: 'altura btn-mobile-footer--primeiro ml-0 btn-responsivo', onClick: () => {
                                setMobileView('login');
                                history.push({
                                    pathname: '/login',
                                    search: `?mobileView=login&redirect=${window.location.pathname + encodeURIComponent(window.location.search)}`
                                });
                            } },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { className: 's16 mr-1', icon: free_solid_svg_icons_1.faUserLock }),
                            t('Entrar')),
                        serviceData !== null ? (react_1.default.createElement(MobileStyles_1.MobileButton, { className: 'altura btn-mobile-footer--segundo ml-0', onClick: () => {
                                setMobileView('services');
                            } },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { className: 's16 mr-1', icon: free_solid_svg_icons_1.faCogs }),
                            t('MobileLayout.Atendimento'))) : '',
                        faqsData !== null ? (react_1.default.createElement(MobileStyles_1.MobileButton, { className: 'altura btn-mobile-footer--segundo ml-0', onClick: () => {
                                setMobileView('faqs');
                            } },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { className: 's16 mr-1', icon: free_solid_svg_icons_1.faQuestion }),
                            t('DuvidasFrequentes'))) : '',
                        react_1.default.createElement(MobileStyles_1.MobileButton, { className: 'altura btn-mobile-footer--segundo ml-0', onClick: () => {
                                setMobileView('suggestions_and_links');
                            } },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { className: 's16 mr-1', icon: free_solid_svg_icons_1.faComments }),
                            t('MobileLayout.LinksESugestoes')),
                        sectionsData !== null && (sectionsData === null || sectionsData === void 0 ? void 0 : sectionsData.length) > 0 ? (react_1.default.createElement(MobileStyles_1.MobileButton, { className: 'altura btn-mobile-footer--segundo ml-0', onClick: () => {
                                setMobileView('featured_and_news');
                            } },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { className: 's16 mr-1', icon: free_solid_svg_icons_1.faNewspaper }),
                            t('MobileLayout.DestaquesENoticias'))) : '')))) : getContent())));
};
const mapStateToProps = (state) => ({
    instituicaoRx: state.instituicao.data,
    opcoesConsultaRx: state.pesquisa.opcoesConsulta,
    consultaRx: state.pesquisa.consulta,
    loadingRx: state.pageConfig.loading,
});
exports.default = (0, react_redux_1.connect)(mapStateToProps)((0, react_router_dom_1.withRouter)(MobileLayout));
